import { mobileMaxWidth, tabletMinWidth, tabletMaxWidth, desktopMinWidth, desktopMaxWidth } from '../base/grid';
export default (function (screenWidth) {
  if (screenWidth <= mobileMaxWidth) {
    return 'mobile';
  }

  if (screenWidth >= tabletMinWidth && screenWidth <= tabletMaxWidth) {
    return 'tablet';
  }

  if (screenWidth >= desktopMinWidth && screenWidth <= desktopMaxWidth) {
    return 'desktop';
  }

  return 'largeDesktop';
});